import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { DeliveryLocation } from '../models/delivery-location.model';
import { ChooseLocation, Timeslot } from '../models';

export class ChooseLocationState implements IStateSlice {
  public isLoading: boolean;
  public isMenuLoading: boolean;
  public failures: AppStateFailure;
  public email: string;
  public chooseLocation: any;
  public locationTimeslot: any;
  public locationMenus: any;
  public deliveryLocation: DeliveryLocation;
  public backBtnValue: string;
  public selectedLocation: ChooseLocation;
  public selectedTimeslot: Timeslot;
  public isTimeslotExpired: boolean;
  public locationPropTypes: any;
  public acceptedAgeRestrictionYears: any;

  constructor() {
    this.isLoading = false;
    this.isMenuLoading = false;
    this.failures = null;
    this.chooseLocation = null;
    this.locationTimeslot = null;
    this.locationMenus = null;
    this.deliveryLocation = null;
    this.backBtnValue = null;
    this.selectedLocation = null;
    this.selectedTimeslot = null;
    this.isTimeslotExpired = false;
    this.locationPropTypes = [];
    this.acceptedAgeRestrictionYears = [];
  }
}
